import { render, staticRenderFns } from "./DevHomeSlider.vue?vue&type=template&id=fdc5b9a8&scoped=true"
import script from "./DevHomeSlider.vue?vue&type=script&lang=js"
export * from "./DevHomeSlider.vue?vue&type=script&lang=js"
import style0 from "./DevHomeSlider.vue?vue&type=style&index=0&id=fdc5b9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc5b9a8",
  null
  
)

export default component.exports